import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import apiendpoints from "../apiendpoints.json";
import ReCAPTCHA from "react-google-recaptcha";
import ReCAPTCHAComponent from "./GoogelRecaptcha/googleCaptcha";
import Thanku from "./HomePageComp/Thanku";

const FormComponent = () => {
  const emailValidation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneValidation = /^(?:\+?\d{1,3}[ -]?)?(?:\d{3,5}[- ]?)?\d{10}$/;
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("Equity Research Mart - Enquiry");
  const [body, setBody] = useState("");
  const [phone, setPhone] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const [buttonEnable, setButton] = useState(true);
  const [showThank, setThank] = useState(false);

  const handleCaptchaChange = (value) => {
    setIsCaptchaValid(!!value);
  };
  const validate = () => {
    let valid = true;

    if (!emailValidation.test(email)) {
      setEmailError("Invalid email address");
      valid = false;
    } else {
      setEmailError("");
    }

    if (!phoneValidation.test(phone)) {
      setPhoneError("Invalid phone number");
      valid = false;
    } else {
      setPhoneError("");
    }

    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return; // Stops form submission if validation fails
    }
    // if(validate()){
    //   setloader(true);
    // }
    setButton(false);
    setIsCaptchaValid(false);

    const formData = {
      email,
      subject,
      message: body,
      State: state,
      Country: country,
      City: city,
      mobile: phone,
      nameUser: name,
      entity: "equity",
    };

    try {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-11496349823/wuRHCO7it_cZEP_A8ekq",
        });
        console.log("Google Ads Conversion triggered");
      } else {
        console.warn("gtag is not loaded yet");
      }
    } catch (error) {
      console.error("Error in gtag:", error);
    }

    try {
      const response = await fetch(apiendpoints.enquiryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "equity",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Failed to send mail:", response.status, errorText);
        toast.error("Failed to send mail");
      }

      setButton(true);
      setIsCaptchaValid(true);
      setThank(true);
      toast.success("Thanks for contacting us!");

      setEmail("");
      setSubject("Equity Research Mart - Enquiry");
      setBody("");
      setPhone("");
      setName("");
      setCountry("");
      setState("");
      setCity("");
    } catch (error) {
      console.error("Error sending mail:", error);
      toast.error("Failed to send mail");
      setButton(true);
      setIsCaptchaValid(true);
    }
  };

  return (
    <div className="relative z-10 w-full md:w-1/2 bg-white/20 md:p-6 p-2 rounded-lg shadow-lg backdrop-blur-md">
      <h2 className="text-white text-xl font-semibold mb-4">
        Get Started Today!
      </h2>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="p-2 rounded-md bg-white/80 text-gray-800 outline-none"
          required
        />
        <input
          type="email"
          placeholder="Your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="p-2 rounded-md bg-white/80 text-gray-800 outline-none"
          required
        />
        {emailError && <p className="text-red-500 text-sm">{emailError}</p>}
        <input
          type="tel"
          placeholder="Your Phone"
          // pattern="[0-9]{10}"
          // maxLength={10}
          // minLength={10}
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="p-2 rounded-md bg-white/80 text-gray-800 outline-none"
          required
        />
        {phoneError && <p className="text-red-500 text-sm">{phoneError}</p>}

        <input
          type="text"
          placeholder="Your City"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="p-2 rounded-md bg-white/80 text-gray-800 outline-none"
          required
        />
        <div className="place-self-start md:col-span-2 lg:col-span-3">
          ``
          <ReCAPTCHAComponent onChange={handleCaptchaChange} />
        </div>

        <button
          type="submit"
          className={`bg-[#2db928] text-white py-2 rounded-md font-semibold ${
            !isCaptchaValid
              ? "opacity-50 cursor-not-allowed"
              : "hover:bg-[#2db928]/80 transition-transform transform hover:scale-105"
          }`}
          disabled={!isCaptchaValid || !buttonEnable}
        >
          Submit
        </button>
      </form>

      <ToastContainer
        autoClose={3000}
        limit={2}
        hideProgressBar={true}
        newestOnTop={true}
      ></ToastContainer>
    </div>
  );
};

export default FormComponent;
